export {
  formatPropertyRegistrationUrl,
  formatProperty,
  formatPropertyTitle,
  formatPropertyTitleUrl,
  formatPropertyDescriptionJsonLd,
  removeAccents,
  formatImageLdJson,
  formatStringArraySearchParam,
  generateKeywords,
} from "./format/format";
export {
  calculateGeneralValues,
  calculateDiscount,
  calculatePrice,
  hasFinancingSupport,
  getTaxAuctionCommision,
  getTaxITBI,
  getTaxFRJ,
  getTaxEscriture,
  getTaxRegister,
  getTaxIPTU,
  getTaxRealStateAgent,
  getTaxGovIRPF,
  bankLoanPercentage,
  getTaxEscriturePercentage,
  getTaxITBIPercentage,
  getTaxRegisterPercentage,
  getTaxFRJPercentage,
  getTaxConsultantService,
  annualInterestRatePercentage,
  getTaxCondominium,
  getAuctionCommisionPercentage,
  hasAuctionCommision,
} from "./viability/viability";
export * from "./queries";
export { sortProfit } from "./sort/sort";
export { formatCityName } from "./cities/cities";
